import React from 'react'
import { Outlet } from 'react-router-dom'

function MainPayable() {
    return (
        <div className="w-full h-full">
        <Outlet/>
        </div>
      )
    }
    
export default MainPayable